module.exports = __webpack_public_path__ + "img/list-play.8484cdaf.png";